export const formatContractValue = (value: string, currencyCode: string): string =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value));
